<template>
  <span v-if="src" class="img-code-wrap" @click="changeImg">
    <img :src="src" alt="" />
  </span>
</template>
<script>
import { api_post } from '@/utils/http.ts'
import { msgTip } from '@/utils/urlUtils'
export default {
  name: 'ImgCode',
  components: {},
  data() {
    return {}
  },
  props: {
    src: {
      default: '',
      type: String
    }
  },
  methods: {
    changeImg() {
      this.$emit('get_new_img')
    }
  }
}
</script>
<style lang="scss">
.img-code-wrap {
  cursor: pointer;
  text-align: center;
  display: inline-block;
}
</style>
